export default __webpack_public_path__ + "static/media/group_level_img.9d01f98c.svg";